import React from 'react';
import Header from 'app/components/layout/Header';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Progress, Badge, Label } from 'reactstrap';
import Isvg from 'react-inlinesvg';
import _ from 'lodash';
import classnames from 'classnames';
import { IMatchPayment } from 'app/ducks/matchPayments/types';
import { parseAmount, friendlyDate, parseStatus } from 'app/utils/parsers';
import ConnectionGroup from 'app/components/general/ConnectionGroup';
import Button from 'app/components/general/Button';
import SectionGroup from 'app/components/general/SectionGroup';
import StatusBadge from 'app/components/general/StatusBadge';
import CopyCaption from 'app/components/general/CopyCaption';
import IconModal from 'app/components/general/IconModal';
import * as matchPaymentActions from 'app/ducks/matchPayments/actions';
import BadgeWithTooltip from 'app/components/general/BadgeWithTooltip';
import history from 'app/routes/history';

import * as paymentEventsSelectors from 'app/ducks/paymentEvents/selectors';
import { parsePaymentStatus } from 'app/ducks/paymentEvents/selectors';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as matchPaymentsSelectors from 'app/ducks/matchPayments/selectors';
import * as organisationsSelectors from 'app/ducks/organisations/selectors';
import * as receiptActions from 'app/ducks/receipts/actions';

import * as receiptsSelectors from 'app/ducks/receipts/selectors';
import {
  IReceiptsSelector,
} from 'app/types/selector';
import CompetitionIcon from 'app/images/icons/organisation.svg';
import MatchIcon from 'app/images/icons/events.svg';
import TeamIcon from 'app/images/icons/team.svg';
import EditIcon from 'app/images/icons/edit.svg';
import Receipt from 'app/components/matches/Receipt';

// import TransferPayment from './TransferPayment';
// import RefundPayment from './RefundPayment';

interface IMatchPaymentDetailProps {
  actions?: any;
  match?: any;
  organisations?: any;
  receipts?: IReceiptsSelector;
  matchPayments?: any;
  appReady?: boolean;
}

interface IMatchPaymentDetailState {
  initialFilter: any;
  error?: string;
  transferPaymentModalOpen?: boolean;
  refundPaymentModalOpen?: boolean;
}

function selector(state) {
  return {
    matchPayments: matchPaymentsSelectors.getMatchPayments(state),
    organisations: organisationsSelectors.getOrganisations(state),
    receipts: receiptsSelectors.getReceipts(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  receiptActions,
  matchPaymentActions,
);

@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  }),
)
export default class MatchPaymentDetail extends React.Component<IMatchPaymentDetailProps, IMatchPaymentDetailState> {
  static defaultProps: IMatchPaymentDetailProps = {
    actions: undefined,
    match: undefined,
    matchPayments: undefined,
    organisations: undefined,
    receipts: undefined,
    appReady: false,
  };

  state: IMatchPaymentDetailState = {
    addPersonToPaymentModalOpen: false,
    transferPaymentModalOpen: false,
    refundPaymentModalOpen: false,
  };

  componentDidMount(): void {
    this.props.actions.getReceipt(
      { id: this.props.match.params.matchPaymentId, receiptType: 'match-payments' },
    );
    this.props.actions.getMatchPayment(this.props.match.params.matchPaymentId);
  }

  handleOpenAddPersonPaymentModal = (e): void => {
    e.preventDefault();
    this.setState({ addPersonToPaymentModalOpen: true });
  };

  handleCloseAddPersonPaymentModal = (e): void => {
    e.preventDefault();
    this.setState({ addPersonToPaymentModalOpen: false });
  };

  handleSavedAddPersonPaymentModal = (e): void => {
    this.props.actions.getMatchPayment(this.props.match.params.matchPaymentId);
    this.setState({ addPersonToPaymentModalOpen: false });
  };

  handleOpenTransferPaymentModal = (e): void => {
    e.preventDefault();
    this.setState({ transferPaymentModalOpen: true });
  };

  handleCloseTransferPaymentModal = (e): void => {
    e.preventDefault();
    this.setState({ transferPaymentModalOpen: false });
  };

  handleSavedTransferPaymentModal = (e): void => {
    this.props.actions.getMatchPayment(this.props.match.params.matchPaymentId);
    this.setState({ transferPaymentModalOpen: false });
  };

  handleOpenRefundPaymentModal = (e): void => {
    e.preventDefault();
    this.setState({ refundPaymentModalOpen: true });
  };

  handleCloseRefundPaymentModal = (e): void => {
    e.preventDefault();
    this.setState({ refundPaymentModalOpen: false });
  };

  handleSavedRefundPaymentModal = (e): void => {
    this.props.actions.getMatchPayment(this.props.match.params.matchPaymentId);
    this.setState({ refundPaymentModalOpen: false });
  };

  handleAddPersonToPayment = (e): void => {
    const payload = {
      paymentType: 'event-variable-addition',
      matchPayment: {
        id: this.props.match.params.matchPaymentId,
      },
    };
    const newMatchPayment = this.props.actions.createMatchPayment(payload, (newMatchPaymentId) => {
      if (newMatchPaymentId !== undefined) {
        history.push(`/payment/match/add/${newMatchPaymentId}/review`);
      }
    });
  }

  handleSubmitForfeit = (fixtureMatchId, groupId): void => {
    history.push(
      `/forfeit/${fixtureMatchId}/${groupId}/submit`,
    );
  }

  buildActions = (matchPayment: IMatchPayment) => {
    const actions = [];

    // if (matchPayment.subscriptionPaymentStatus === 'paid' && matchPayment.subscriptionPaymentTransferStatus === null) {
    //   actions.push(<Button
    //     className="btn-standard btn-small btn-2 margin-right-10 margin-bottom-10"
    //     noLoading
    //     onClick={this.handleOpenTransferPaymentModal}
    //   >
    //     Transfer Payment
    //   </Button>);
    // }
    if (matchPayment.subscriptionPaymentStatus === 'paid' && matchPayment.paymentType === 'event-variable' && matchPayment.subscriptionPaymentTransferStatus === null) {
      actions.push(<Button
        className="btn-standard btn-small btn-2 margin-right-10 margin-bottom-10"
        noLoading
        onClick={this.handleAddPersonToPayment}
      >
        Pay for extra player/s
      </Button>);
    }
    if (matchPayment.subscriptionPaymentStatus === 'paid' && matchPayment.subscriptionPaymentForfeitStatus === null) {
      actions.push(<Button
        className="btn-standard btn-small btn-2 margin-right-10 margin-bottom-10"
        noLoading
        onClick={(e) => this.handleSubmitForfeit(matchPayment.fixtureMatch.id, matchPayment.group.id)}
      >
        Submit Forfeit
      </Button>);
    }
    // if (_.includes(['paid', 'paid-teammo'], matchPayment.subscriptionPaymentStatus) && matchPayment.subscriptionPaymentTransferStatus === null) {
    //   actions.push(<Button
    //     className="btn-standard btn-small btn-2 margin-right-10 margin-bottom-10"
    //     noLoading
    //     onClick={this.handleOpenRefundPaymentModal}
    //   >
    //     Refund Payment
    //   </Button>);
    // }
    return actions;
  }

  render(): React.ReactNode {
    const matchPayment: IMatchPayment = this.props.matchPayments.currentMatchPayment;
    const receipt = this.props.receipts.currentReceipt;
    const { fixtureMatch } = receipt;

    const statuses = parsePaymentStatus({
      paymentStatus: matchPayment.subscriptionPaymentStatus,
      paymentStatusDue: matchPayment.subscriptionPaymentDueStatus,
      transferStatus: matchPayment.subscriptionPaymentTransferStatus,
      adminStatus: matchPayment.subscriptionPaymentAdminStatus,
      forfeitStatus: matchPayment.subscriptionPaymentForfeitStatus,
      fixtureMatchStatus: matchPayment.fixtureMatchStatus,
    }, {
      paymentStatus: matchPayment.oppositionSubscriptionPaymentStatus,
      transferStatus: matchPayment.oppositionSubscriptionPaymentTransferStatus,
      adminStatus: matchPayment.oppositionSubscriptionPaymentAdminStatus,
      forfeitStatus: matchPayment.oppositionSubscriptionPaymentForfeitStatus,
    }, true);
    const actions = this.buildActions(matchPayment);

    const isLoading = this.props.matchPayments.isLoading && matchPayment.id !== this.props.match.params.matchPaymentId;
    return (
      <div>
        {/* <IconModal
          title="Transfer Payment"
          icon={EditIcon}
          handleCancel={this.handleCloseTransferPaymentModal}
          isOpen={this.state.transferPaymentModalOpen}
        >
          <TransferPayment
            {...this.props}
            matchPayment={matchPayment}
            afterSubmit={this.handleSavedTransferPaymentModal}
          />
        </IconModal>
        <IconModal
          title="Refund Payment"
          icon={EditIcon}
          handleCancel={this.handleCloseRefundPaymentModal}
          isOpen={this.state.refundPaymentModalOpen}
        >
          <RefundPayment
            {...this.props}
            matchPayment={matchPayment}
            afterSubmit={this.handleSavedRefundPaymentModal}
          />
        </IconModal> */}
        <div className="row">
          <div className="col">
            <Header
              title={parseAmount(matchPayment.amount)}
              titleUnit="AUD"
              isLoading={isLoading}
              badge={(
                <div className="payment-badge-group">
                  {
                    _.map(statuses, (statusBadge) => (
                      <BadgeWithTooltip
                        className="payment-badge"
                        targetId="match-payment-detail-status"
                        key={statusBadge.text}
                        color={statusBadge.colour}
                        tooltipText={statusBadge.description}
                      >
                        {statusBadge.text}
                      </BadgeWithTooltip>
                    ))
                  }
                </div>
              )}
              descriptors={
                [
                  {
                    icon: <Isvg src={MatchIcon} />,
                    descriptor: matchPayment.matchRoundName,
                  },
                  {
                    icon: <Isvg src={TeamIcon} />,
                    descriptor: matchPayment.groupName,
                  },
                  {
                    icon: <Isvg src={CompetitionIcon} />,
                    descriptor: matchPayment.competitionName,
                  },
                ]
              }
              metadata={[
                {
                  title: 'Date Paid',
                  value: matchPayment.purchasedAt !== null ? friendlyDate(matchPayment.purchasedAt) : '',
                },
                {
                  title: 'Type',
                  value: 'Match',
                },
                {
                  title: 'Payment Method',
                  value: _.includes(['paid', 'paid-transferred'], matchPayment.subscriptionPaymentStatus) ? 'Credit / Debit Card' : '',
                },
                {
                  title: 'Match Status',
                  value: parseStatus(matchPayment.fixtureMatchStatus),
                },
              ]}
            />
          </div>
        </div>
        <div className="main-content">
          <div className="row">
            {/* <div className={classnames('col col-12', { 'col-lg-6': actions.length > 0 }, { 'col-lg-8 col-xlg-6': actions.length === 0 })}>
              <SectionGroup
                title="Status"
                isLoading={isLoading}
              >
                <div className={classnames({ 'd-none': _.isEmpty(matchPayment.subscriptionPaymentStatus) }, 'row')}>
                  <div className="col col-4 text-grey d-flex align-items-center">
                    Payment Status
                  </div>
                  <div className="col text-left">
                    <StatusBadge
                      className="event-card-badge float-left"
                      // paymentText={matchPayment.subscriptionPaymentStatus}
                      teamStatus={{
                        paymentStatus: matchPayment.subscriptionPaymentStatus,
                        paymentStatusDue: matchPayment.subscriptionPaymentDueStatus,
                      }}
                    />
                  </div>
                </div>
                <div className={classnames({ 'd-none': _.isEmpty(matchPayment.subscriptionPaymentTransferStatus) }, 'row with-margin-top-10')}>
                  <div className="col col-4 text-grey d-flex align-items-center">
                    Transfer Status
                  </div>
                  <div className="col">
                    <StatusBadge
                      className="event-card-badge float-left"
                      defaultText=""
                      teamStatus={{
                        transferStatus: matchPayment.subscriptionPaymentTransferStatus,
                      }}
                    // paymentText={matchPayment.subscriptionPaymentTransferStatus}
                    />
                  </div>
                </div>
                <div className={classnames({ 'd-none': _.isEmpty(matchPayment.subscriptionPaymentAdminStatus) }, 'row with-margin-top-10')}>
                  <div className="col col-4 text-grey d-flex align-items-center">
                    Admin Status
                  </div>
                  <div className="col">
                    <StatusBadge
                      className="event-card-badge float-left"
                      defaultText=""
                      // paymentText={matchPayment.subscriptionPaymentAdminStatus}
                      teamStatus={{
                        adminStatus: matchPayment.subscriptionPaymentAdminStatus,
                      }}
                      otherTeamStatus={{
                        adminStatus: matchPayment.oppositionSubscriptionPaymentAdminStatus,
                      }}
                    />
                  </div>
                </div>
                <div className={classnames({ 'd-none': _.isEmpty(matchPayment.subscriptionPaymentForfeitStatus) && _.isEmpty(matchPayment.oppositionSubscriptionPaymentForfeitStatus) }, 'row with-margin-top-10')}>
                  <div className="col col-4 text-grey d-flex align-items-center">
                    Forfeit Status
                  </div>
                  <div className="col">
                    <StatusBadge
                      className="event-card-badge float-left"
                      defaultText=""
                      paymentText={matchPayment.subscriptionPaymentForfeitStatus}
                      teamStatus={{
                        forfeitStatus: matchPayment.subscriptionPaymentForfeitStatus,
                      }}
                      otherTeamStatus={{
                        forfeitStatus: matchPayment.oppositionSubscriptionPaymentForfeitStatus,
                      }}
                    />
                  </div>
                </div>
                <div className={classnames({ 'd-none': _.isEmpty(matchPayment.fixtureMatchStatus) }, 'row with-margin-top-10')}>
                  <div className="col col-4 text-grey d-flex align-items-center">
                    Match Status
                  </div>
                  <div className="col">
                    <StatusBadge
                      className="event-card-badge float-left"
                      defaultText=""
                      paymentText={matchPayment.fixtureMatchStatus}
                    />
                  </div>
                </div>
              </SectionGroup>
            </div> */}

            {actions.length > 0 && (
              <div className="col col-12 col-lg-6 col-xlg-6 with-margin-top-extra-md">
                <SectionGroup title="Actions" isLoading={isLoading}>
                  <div className="">
                    {_.map(actions, (a) => a)}
                  </div>
                </SectionGroup>
              </div>
            )}
          </div>
          <div className="row with-margin-top-extra">
            <div className={classnames({ 'col col-12 col-lg-6 col-xlg-6': matchPayment.forfeit?.data !== null }, { 'col col-12 col-lg-8 col-xlg-6': isLoading || matchPayment.forfeit?.data === null })}>
              <SectionGroup title="Payment Receipt" isLoading={isLoading}>
                {/* <div className="row">
                  <div className="col col-4 text-grey">
                    Payment Reference
                  </div>
                  <div className="col">
                    {matchPayment.friendlyReference}
                  </div>
                </div> */}
                <Receipt
                  {...receipt}
                  matchCardData={paymentEventsSelectors.getPaymentEventForMatchCard(
                    fixtureMatch,
                    receipt?.group?.id,
                  )}
                />
              </SectionGroup>
            </div>
          </div>
          <div className={classnames({ 'd-none': isLoading || matchPayment.refundStatus === null }, 'row with-margin-top-extra')}>
            <div className="col col-12 col-lg-8 col-xlg-6">
              <SectionGroup title="Refund Details" isLoading={isLoading}>
                <div className="row">
                  <div className="col col-4 text-grey">
                    Refund Status
                  </div>
                  <div className="col">
                    {parseStatus(matchPayment.refundStatus)}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Refund Amount
                  </div>
                  <div className="col">
                    {parseAmount(matchPayment.refundAmount)}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Refunded Date
                  </div>
                  <div className="col">
                    {friendlyDate(matchPayment?.refundedAt)}
                  </div>
                </div>
              </SectionGroup>
            </div>
          </div>
          <div className="row with-margin-top-extra">
            <div className="col col-12 col-lg-8 col-xlg-6">
              <SectionGroup title="Match Information" isLoading={isLoading}>
                <div className="row">
                  <div className="col col-4 text-grey">
                    Round
                  </div>
                  <div className="col">
                    {matchPayment.matchRoundName}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Match Date
                  </div>
                  <div className="col">
                    {friendlyDate(matchPayment.matchAt)}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Location
                  </div>
                  <div className="col">
                    {matchPayment.matchLocationName}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Opposition Team
                  </div>
                  <div className="col">
                    {matchPayment.matchOppositionTeamName}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Section
                  </div>
                  <div className="col">
                    {matchPayment.matchSectionName}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Season
                  </div>
                  <div className="col">
                    {matchPayment.matchSeasonName}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Competition
                  </div>
                  <div className="col">
                    {matchPayment.competitionName}
                  </div>
                </div>
              </SectionGroup>
            </div>
          </div>
          {/* <div className="row with-margin-top-extra">
            <div className="col col-12 col-lg-8 col-xlg-6">
              <ConnectionGroup
                title="Connections"
                isLoading={isLoading}
                items={
                  [
                    {
                      type: 'team',
                      title: 'Team',
                      links: [{
                        name: matchPayment.group?.id === matchPayment.matchHomeTeamId ? matchPayment.matchHomeTeamName : matchPayment.matchOppositionTeamName,
                        id: matchPayment.group?.id === matchPayment.matchHomeTeamId ? matchPayment.matchHomeTeamId : matchPayment.matchOppositionTeamId,
                      }],
                    },
                    {
                      type: 'team',
                      title: 'Opposition',
                      links: [{
                        name: matchPayment.group?.id !== matchPayment.matchHomeTeamId ? matchPayment.matchHomeTeamName : matchPayment.matchOppositionTeamName,
                        id: matchPayment.group?.id !== matchPayment.matchHomeTeamId ? matchPayment.matchHomeTeamId : matchPayment.matchOppositionTeamId,
                      }],
                    },
                    {
                      type: 'competition',
                      title: 'Competition',
                      links: [{
                        name: matchPayment.competitionName,
                        id: matchPayment.competitionId,
                      }],
                    },
                  ]
                }
              />
            </div>
          </div> */}
          {/* <div className="row with-margin-top-extra">
            <div className="col col-12 col-lg-8 col-xlg-6">
              <SectionGroup title="Connections" isLoading={this.props.matchPayments.isLoading}>
                <div className="row">
                  <div className="col col-4 text-grey">
                    Initial Notification (SMS)
                  </div>
                  <div className="col">
                    <Checkbox
                      className="with-label"

                      checked
                    />
                    <Label className="d-inline">Sent 1.30pm on 30 April 2021</Label>
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Initial Notification (Email)
                  </div>
                  <div className="col">
                    <Checkbox
                      className="with-label"
                      checked
                    />
                    <Label className="d-inline">Sent 1.30pm on 30 April 2021</Label>
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    3 Day Reminder (SMS)
                  </div>
                  <div className="col">
                    <Checkbox
                      className="with-label"
                      checked={false}
                    />
                    <Label className="d-inline">Will be sent at 1.30pm on 30 April 2021</Label>
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    3 Day Reminder (Email)
                  </div>
                  <div className="col">
                    <Checkbox
                      className="with-label"
                      checked={false}
                    />
                    <Label className="d-inline">Will be sent at 1.30pm on 30 April 2021</Label>
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    1 Day Reminder (SMS)
                  </div>
                  <div className="col">
                    <Checkbox
                      className="with-label"
                      checked={false}
                    />
                    <Label className="d-inline">Will be sent at 1.30pm on 30 April 2021</Label>
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    1 Day Reminder (Email)
                  </div>
                  <div className="col">
                    <Checkbox
                      className="with-label"
                      checked={false}
                    />
                    <Label className="d-inline">Will be sent at 1.30pm on 30 April 2021</Label>
                  </div>
                </div>
              </SectionGroup>
            </div>
          </div> */}
          <div className="row with-margin-top-extra">
            <div className="col">
              {/* <MatchPaymentCollectionsTable
                {...this.props.matchPaymentCollections}
                headerTitle="Payment Collections"
                appReady={this.props.appReady}
                actions={this.props.actions}
                isLoading={!this.props.appReady}
                persistentFilterConfig={{
                  matchPaymentId: matchPayment.id,
                }}
                selectMatchPaymentCollection={this.props.actions.selectMatchPayment}
              /> */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
